import { render, staticRenderFns } from "./Unbinding.vue?vue&type=template&id=1ab13c4b&scoped=true&"
import script from "./Unbinding.vue?vue&type=script&lang=js&"
export * from "./Unbinding.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/css.css?vue&type=style&index=0&id=1ab13c4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab13c4b",
  null
  
)

export default component.exports